export default __webpack_public_path__ + "static/media/LOGO_PLACEHOLDER.6fc45b94.jpg";